import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LabelQuestion } from '@interfaces/questions';
import { WorkflowItemKeyDirective } from '@workflow/directives/workflow-item-key/workflow-item-key.directive';

@Component({
	selector: 'workflow-label-question',
	templateUrl: './label-question.component.html',
	styleUrls: ['./label-question.component.scss'],
})
export class LabelQuestionComponent implements OnInit {

	@Input() question: LabelQuestion;
	@Input() finishedAndLocked = false;

	@Output() valid: EventEmitter<boolean> = new EventEmitter();

	constructor(
		private workflowItemKey: WorkflowItemKeyDirective,
	) {
	}

	ngOnInit(): void {
		this.valid.emit(!this.question.isBlocking);
		if (!this.question.isBlocking && !this.finishedAndLocked) {
			this.workflowItemKey.setProperty(true);
		}
	}

}
